import React, { Component }  from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { AccountDemo }       from "../../utils/StaticIds";
import "../../css/workout/WorkoutDetail.css";

export default class SaveAllExerciseRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elapsed: 0,
        };
    }

    render() {
        var cmark = "gray"
        
        var checkout_btn = <span className="workoutDetailsSaveAllLink workoutDetailSaveAllProductTour"
                                  onClick = {this.props.handleSubmitCheckAll}>

                                <span className="workoutDetailsSaveAllText ">SAVE ALL</span>
                                <img src={require('../../images/utils/checkmark_sq_'+cmark+'.png')} width="26" height="26"/>
                            </span>
        if(this.props.block_finished === true)
            cmark = "green";

        if(AccountDemo === this.props.athlete_id) checkout_btn = "";

        return  <span className="workoutDetailsSaveAllRow">
                    { checkout_btn }
                </span>
    }
}



// WEBPACK FOOTER //
// ./src/components/workout/SaveAllExerciseRow.js